export const iconFontAwesomeMapsBridgeWater = (
	<i className="fa-solid fa-bridge-water"></i>
);
